import { i18n } from 'i18n';

import type { MessageSettings } from '@shared/services/systemSettings/types/getMessageSettings.types';
import { getMessageSettingByCode } from '@shared/utils/messagesetting';

import {
  ENETS_DEFAULT_ERROR_TEXT,
  ENETS_ERROR_LIST,
  ENETS_TOKENISATION_ERROR_LIST,
  PAYMENT_RECEIPT_ACKNOWLEDGEMENT_UNSUCCESS,
  PAYMENT_SUCCESS_CODE,
  PG,
  PG_ERROR_LEN,
} from '../constants';
import type { ENETSErrorList } from '../types/payments.types';

const getTranslation = (key: string) => i18n.t(key, { ns: 'payments' });

export const getENETSError = (statusCode: string, documentTexts: MessageSettings[] | null) => {
  let errorLst = '';
  if (statusCode === PAYMENT_SUCCESS_CODE || statusCode === '') return '';
  let defaultError = '';
  let isPGError = false;
  let pgError = '';
  if (statusCode?.toUpperCase().startsWith(PG)) {
    isPGError = true;
    const pgIndex = statusCode.indexOf(PG);
    pgError = statusCode.substring(pgIndex, pgIndex + PG_ERROR_LEN);
    // Would reach here incase of tokenization(not supported now) or PG error
    defaultError = getTranslation(ENETS_DEFAULT_ERROR_TEXT);
    errorLst = getMessageSettingByCode(ENETS_TOKENISATION_ERROR_LIST, documentTexts)?.Value || '';
  } else {
    defaultError = getTranslation(ENETS_DEFAULT_ERROR_TEXT);
    errorLst = getMessageSettingByCode(ENETS_ERROR_LIST, documentTexts)?.Value || '';
  }
  if (defaultError === '') {
    defaultError =
      getMessageSettingByCode(PAYMENT_RECEIPT_ACKNOWLEDGEMENT_UNSUCCESS, documentTexts)?.Value ||
      getTranslation(ENETS_DEFAULT_ERROR_TEXT);
  }
  errorLst = errorLst.replaceAll('msg', '"msg"').replaceAll('codes', '"codes"');
  if (errorLst !== '') {
    const eNetsErrors: ENETSErrorList = JSON.parse(errorLst);
    const msg = eNetsErrors.find((element) => element.codes.includes(statusCode))?.msg;
    if (msg) {
      return isPGError ? `${msg} (${pgError})` : msg;
    }
    return defaultError;
  }
  return defaultError;
};
